export default __webpack_public_path__ + "static/media/kehoe_remake.4e13a51f.jpg";